import { CaretDownOutlined, CaretRightOutlined } from "@ant-design/icons";
import { Checkbox, Table, TableColumnsType } from "antd";
import React, { memo, useEffect, useMemo } from "react";
import useToast from "../../../../../hook/useToast";
import { DataTypeDecentralization, IFieldsDecentralization, IFieldsDecentralizationChildren } from "../../CreateGroupRole/indexV2";

interface Prop {
    listFieldsDecentralization: IFieldsDecentralization[]

    setListFieldsDecentralization: React.Dispatch<React.SetStateAction<IFieldsDecentralization[]>>
}
const DataDecentralization: React.FC<Prop> = ({
    listFieldsDecentralization,
    setListFieldsDecentralization
}) => {




    const allViewChecked = useMemo(
        () =>
            listFieldsDecentralization.every(
                (item) =>
                    item.view &&
                    (!item.children || item.children.every((child) => child.view))
            ),
        [listFieldsDecentralization]
    );

    const allEditChecked = useMemo(
        () =>
            listFieldsDecentralization.every(
                (item) =>
                    item.edit &&
                    (!item.children || item.children.every((child) => child.edit))
            ),
        [listFieldsDecentralization]
    );

    //#region  Cột  data
    const columns: TableColumnsType<IFieldsDecentralization | IFieldsDecentralizationChildren> = [

        {
            title: 'Tính năng',
            key: 'name',
            dataIndex: 'name',
            className: 'w-386-px ',
        },
        {
            title: (
                <Checkbox
                    checked={allViewChecked}
                    onChange={(e) => handleCheckAll("view", e.target.checked)}
                >
                    <span className="text-white"> Xem</span>
                </Checkbox>
            ),
            dataIndex: 'view',
            render: (_, value: IFieldsDecentralization | IFieldsDecentralizationChildren) =>
                <Checkbox
                    className="size-check-box size-check-box-inner p-checkbox icon-check-box"
                    checked={value.view}
                    onChange={(e) => handleChangeType(
                        e.target.checked, value.key, "view", (value as IFieldsDecentralizationChildren).parentId
                    )
                    }
                />,

            className: 'w-100-px',
            align: 'center',
        },

        {
            title: (
                <Checkbox
                    checked={allEditChecked}
                    onChange={(e) => handleCheckAll("edit", e.target.checked)}
                >
                    <span className="text-white"> Sửa</span>
                </Checkbox>
            ),
            dataIndex: 'edit',
            render: (_, value: IFieldsDecentralization | IFieldsDecentralizationChildren) =>
                <Checkbox
                    className="size-check-box size-check-box-inner p-checkbox icon-check-box"
                    checked={value.edit}
                    onChange={(e) => handleChangeType(
                        e.target.checked, value.key, "edit", (value as IFieldsDecentralizationChildren).parentId
                    )
                    }
                />,

            className: 'w-100-px',
            align: 'center',
        },

    ];
    //#endregion

    // 🧩 Hàm xử lý tick toàn bộ cột
    const handleCheckAll = (field: "view" | "edit", checked: boolean) => {
        setListFieldsDecentralization((prev) =>
            prev.map((item) => {
                let updatedParent = {
                    ...item,
                    [field]: checked,
                    children: item.children?.map((child) => ({
                        ...child,
                        [field]: checked,
                    })),
                };

                // logic view <-> edit
                if (field === "edit" && checked) {
                    updatedParent.view = true;
                    updatedParent.children = updatedParent.children?.map((c) => ({
                        ...c,
                        view: true,
                    }));
                }

                if (field === "view" && !checked) {
                    updatedParent.edit = false;
                    updatedParent.children = updatedParent.children?.map((c) => ({
                        ...c,
                        edit: false,
                    }));
                }

                return updatedParent;
            })
        );
    };


    // phạm vi hoạt động
    const handleChangeType = (checked: boolean, key: string, field: 'view' | 'edit', parentId?: number) => {
        setListFieldsDecentralization(prev =>
            prev.map(item => {
                // --- Cập nhật CON ---
                if (parentId !== undefined) {
                    if (item.key !== parentId.toString() || !item.children) return item;
                    const newChildren = item.children.map(child => {
                        if (child.key !== key) return child;
                        let updated = { ...child, [field]: checked };

                        // Auto tick logic
                        if (field === 'edit' && checked) updated.view === false ? updated.view = true : ''
                        if (field === 'view' && !checked) updated.edit === true ? updated.edit = false : '';

                        return updated;
                    });

                    // Tính toán lại cha dựa trên tất cả con
                    const allViewChecked = newChildren.every(c => c.view === true);
                    const allEditChecked = newChildren.every(c => c.edit === true);

                    let updatedParent = {
                        ...item, view: allViewChecked, edit: allEditChecked, children: newChildren,
                    };
                    return updatedParent;
                }

                // --- Cập nhật CHA ---
                if (item.key === key) {
                    const cascadedChildren = item.children
                        ? item.children.map(c => {
                            let updated = { ...c, [field]: checked };
                            if (field === 'edit' && checked) updated.view = true;
                            if (field === 'view' && !checked) updated.edit = false;
                            return updated;
                        })
                        : item.children;

                    let updatedParent = { ...item, [field]: checked, children: cascadedChildren };

                    if (field === 'edit' && checked) {
                        updatedParent.view = true;
                        updatedParent.children = updatedParent.children?.map(c => ({
                            ...c,
                            view: true,
                        }));
                    }

                    if (field === 'view' && !checked) {
                        updatedParent.edit = false;
                        updatedParent.children = updatedParent.children?.map(c => ({
                            ...c,
                            edit: false,
                        }));
                    }

                    return updatedParent;
                }

                return item;
            })
        );
    };

    // fecth data

    useEffect(() => {
        const updated = listFieldsDecentralization.map(item => {
            if (item.children?.length) {
                const allCheckedView = item.children.every(c => c.view);
                const allCheckedEdit = item.children.every(c => c.edit);
                return { ...item, view: allCheckedView, edit: allCheckedEdit };
            }
            return item;
        });
        setListFieldsDecentralization(updated);
    }, [listFieldsDecentralization.length]);

    return (
        <div>
            <div className="pb-18-px">
                <div className="t-table-block ">
                    <Table
                        rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
                        columns={columns}
                        dataSource={listFieldsDecentralization}
                        pagination={false}
                        showSorterTooltip={false}
                        className=" border-end-table  "
                        expandable={{
                            expandIcon: ({ expanded, onExpand, record }) =>
                                record?.children?.length ? (
                                    expanded ? (
                                        <CaretDownOutlined className={` pr-1 text-8E8E8E`} onClick={e => onExpand(record, e)} />
                                    ) : (
                                        <CaretRightOutlined className={` pr-1 text-8E8E8E`} onClick={e => onExpand(record, e)} />
                                    )
                                ) : (
                                    <CaretDownOutlined className={` `} style={{ opacity: 0 }} />
                                ),
                            // defaultExpandAllRows: true
                        }}



                    />
                </div>
            </div>

        </div>
    )
}

export default memo(DataDecentralization)
